import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { useSite } from "../lib/SiteContext";

const HOME_LIMIT = 6;

const ReviewsSection = () => {
  const { content } = useSite();
  const r = content?.reviews || {};
  const items = r.items || [];
  const shown = items.slice(0, HOME_LIMIT);
  const hasMore = items.length > HOME_LIMIT;
  return (
    <section className="section-padding bg-background" data-testid="reviews-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-7">
            <div className="overline mb-4">{r.overline || "Guests on board"}</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-primary leading-[1.05] text-balance">
              {r.title || "Five stars, every time."}
            </h2>
            {r.subtitle && (
              <p className="text-muted-foreground mt-4 max-w-2xl leading-relaxed">{r.subtitle}</p>
            )}
          </div>
          <div className="lg:col-span-5 flex items-end">
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} size={18} className="fill-secondary text-secondary" />
              ))}
              <span className="ml-2 text-sm text-muted-foreground">
                {Number(r.rating || 5).toFixed(1)} average from {items.length} reviews
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {shown.map((rev, i) => (
            <figure
              key={i}
              className="bg-white border border-border p-8 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 flex flex-col"
              data-testid={`review-${i}`}
            >
              <div className="flex gap-1 mb-5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} size={14} className="fill-secondary text-secondary" />
                ))}
              </div>
              <blockquote className="font-serif text-lg md:text-xl text-primary leading-snug mb-6 flex-1">
                &ldquo;{rev.text}&rdquo;
              </blockquote>
              <figcaption>
                <div className="text-sm font-medium text-primary">{rev.name}</div>
                <div className="text-xs text-muted-foreground tracking-wider uppercase">
                  {rev.date || rev.country}
                </div>
                {rev.note && <div className="text-[11px] italic text-muted-foreground mt-1">{rev.note}</div>}
              </figcaption>
            </figure>
          ))}
        </div>

        {hasMore && (
          <div className="mt-12 flex justify-center">
            <Link
              to="/reviews"
              className="btn-outline group inline-flex items-center gap-2"
              data-testid="view-all-reviews"
            >
              Read all {items.length} reviews
              <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewsSection;
